import styled from "styled-components";

const Style = styled.div`
  max-width: calc(100% - 48px);
  margin-left: var(--size-lg);
  overflow: hidden;

  .daf-table {
    padding: 0px;
    margin-top: 0px;
  } 

  .priority-tag {
    width: 94px;
    text-align: center;
  }

  .status-tag {
    width: 62px;
    text-align: center;
  }
`;

export default Style;
